import { Link } from "react-router-dom";

export function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-[#211D19] px-4 py-12 text-slate-200">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="text-sm text-[#C4553B] hover:underline">
          ← Accueil
        </Link>
        <h1 className="mt-6 text-3xl font-bold sm:text-4xl">{title}</h1>
        <div className="prose prose-invert mt-6 max-w-none text-slate-300">{children}</div>
        <div className="mt-16 flex gap-4 border-t border-slate-800 pt-6 text-sm text-slate-500">
          <Link to="/legal/mentions" className="hover:text-slate-300">
            Mentions
          </Link>
          <Link to="/legal/privacy" className="hover:text-slate-300">
            Confidentialité
          </Link>
          <Link to="/legal/terms" className="hover:text-slate-300">
            CGU
          </Link>
        </div>
      </div>
    </div>
  );
}

export function MentionsPage() {
  return (
    <LegalShell title="Mentions légales">
      <p>
        <b>Wérko</b> — plateforme SaaS pour professionnels du BTP en Belgique.
      </p>
      <p>Le contenu détaillé (RCS, TVA, hébergeur, éditeur) sera complété prochainement.</p>
      <p className="text-sm text-slate-500">Contenu à personnaliser.</p>
    </LegalShell>
  );
}

export function PrivacyPage() {
  return (
    <LegalShell title="Politique de confidentialité">
      <p>
        Nous traitons les données personnelles (nom, email) uniquement pour fournir la
        plateforme Wérko et communiquer avec vous.
      </p>
      <p>Les audios de dictée et transcriptions brutes ne sont jamais stockés.</p>
      <p className="text-sm text-slate-500">Contenu à personnaliser.</p>
    </LegalShell>
  );
}

export function TermsPage() {
  return (
    <LegalShell title="Conditions générales d'utilisation">
      <p>
        L&apos;utilisation de la plateforme Wérko est régie par les présentes CGU. À ne pas
        confondre avec les CGV de votre entreprise, uploadées séparément dans vos paramètres.
      </p>
      <p className="text-sm text-slate-500">Contenu à personnaliser.</p>
    </LegalShell>
  );
}
